var image_one = '';
var image_two = '';
var id_service = '';
var oldImage = '';
var newImage = '';

$(document).ready(function(){
    $('#sliderServices').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: $('.sliderServices .prevArrow'),
        nextArrow: $('.sliderServices .nextArrow'),
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
        ]
    });

    setTimeout(function () {
        $('.sectionServices #sliderServices .element').click(function () {
            $('.modalService .name').html($(this).attr('name'));
            $('.modalService .info_desc').html($(this).attr('description'));
            image_one = $(this).attr('image_one');
            image_two = $(this).attr('image_two');
            id_service = $(this).attr('id_service');;
            oldImage = image_two;
            $('.modalService .arrow').css('display','inherit');
            $('.modalService .img_back').css('display','inherit');
            if(image_one == '' && image_two == ''){
                $('.modalService .image_one').css('background-image','url('+https+'img/services/modal/1.jpg)');
                $('.modalService .image_two').css('background-image','none');
                $('.modalService .arrow').css('display','none');
                $('.modalService .img_back').css('display','none');
            }else if(image_two == ''){
                $('.modalService .image_one').css('background-image','url('+https+image_one+')');
                $('.modalService .image_two').css('background-image','none');
                $('.modalService .arrow').css('display','none');
                $('.modalService .img_back').css('display','none');
            }else{
                $('.modalService .image_one').css('background-image','url('+https+image_one+')');
                $('.modalService .image_two').css('background-image','url('+https+image_two+')');
            }
            $('.modalService .arrow').attr('id',3);
            $('.modalService').modal('open');
        });
    },200);

});

$('.modalService .arrow').click(function () {
    $.ajax({
        url: https + "/getImageService",
        method: "POST",
        data: {
            id: this.id,
            service_id: id_service
        },
        success: function (data) {
            if(data != ''){
                newImage = data;
                $('.modalService .image_one').css('background-image','url('+https+oldImage+')');
                $('.modalService .image_two').css('background-image','url('+https+newImage+')');
                oldImage = newImage;
            }else{
                $('.modalService .image_one').css('background-image','url('+https+newImage+')');
                $('.modalService .image_two').css('background-image','url('+https+image_one+')');
                oldImage = image_one;
                $('.modalService .arrow').attr('id',2);
            }
        }
    });
    $('.modalService .arrow').attr('id',parseInt(this.id)+1);
});
